module.exports = __webpack_public_path__ + "img/checkbox-square.81c23d69.svg";